export const P1_BASE_CSS_VARS = {
  "theme-website-p1-color-text": "var(--theme-website-color-text-primary)",
  "theme-website-p1-font-family": "InterVariable",
  "theme-website-p1-font-size": "1.125rem",
  "theme-website-p1-font-weight": "400",
  "theme-website-p1-line-height": "1.4",
  "theme-website-p1-letter-spacing": "0",
};
